import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import './assets/gekko-fonts.scss'
import 'bootstrap-scss/bootstrap-grid.scss'
import 'balloon-css'

import('./assets/app.scss')

import {Promise} from 'es6-promise-polyfill'
import {authHelper, describeUsername, describeUnixTs} from "@/utils";
import $ from "jquery";

import Toasted from 'vue-toasted';

Vue.use(Toasted, {
    theme: "toasted-primary",
    position: "bottom-left",
})

Vue.config.productionTip = false

const eventHub = new Vue()

const measureStringWidth = function (str, cssStyles) {
    const $test = $('<test>').css({
        position: 'absolute',
        top: -9999,
        left: -9999,
        width: 'auto',
        padding: 0,
        whiteSpace: 'pre'
    }).text(str).appendTo('body');

    $test.css(cssStyles);

    const rect = $test[0].getBoundingClientRect();
    const width = rect.width;
    const height = rect.height;
    $test.remove();

    return {width, height};
}

Vue.mixin({
    data() {
        return {
            eventHub
        }
    },
    methods: {
        handleServerSideError(err) {
            return new Promise((resolve, reject) => {
                if (err && err.status === 403) {
                    alert('You are currently logged out. Please log in again!')
                    authHelper.setUserAuthenticated(false)
                    return this.$router.push({
                        name: 'login',
                        query: {
                            redirectTo: this.$route.fullPath,
                            r: 'renew'
                        }
                    })
                } else {
                    reject(err)
                }
            })
        },
        describeUsername: describeUsername,
        describeUnixTs: describeUnixTs,
        onMouseEnterTooltipTarget(event) {
            let $target = $(event.currentTarget);

            let tooltip;

            if (!(tooltip = $target[0].dataset.tooltip)) {
                return;
            }

            const cellPosition = $target.offset(), cellWidth = $target.outerWidth(),
                cellHeight = $target.outerHeight();

            const cssStyles = {
                'font-size': '14px',
                'background': 'rgba(30,30,30,0.95)',
                'border-radius': '8px',
                'color': 'white',
                'padding': '0.5em 1em',
            };

            let singleLineWidth, singleLineHeight;

            const rect = measureStringWidth(tooltip, cssStyles);
            singleLineWidth = rect.width;
            singleLineHeight = rect.height;

            let left = cellPosition.left + cellWidth / 2 - singleLineWidth / 2;
            let width = singleLineWidth;

            if (left + width > window.innerWidth) {
                left -= left + width - window.innerWidth + 4;
            }

            const $tooltipMain = $('<div class="tooltip">');
            const $tooltipArrow = $('<div class="arrow"></div>');

            let tooltipMainStyles = {
                position: 'absolute',
                left: left,
                width: width,
                'animation': 'fadeInToTop 180ms ease-out forwards',
                'animation-delay': '180ms',
                'z-index': 9999,
                'pointer-events': 'none',
                'opacity': 0,
            };

            let tooltipXOffset = $target[0].dataset.tooltipXOffset;
            if (tooltipXOffset) {
                tooltipXOffset = parseInt(tooltipXOffset);
            }

            tooltipXOffset = tooltipXOffset || 0;

            if ($target[0].dataset.tooltipPos === 'up') {
                tooltipMainStyles.top = cellPosition.top - singleLineHeight - 6 + tooltipXOffset;
                $tooltipMain.addClass('tooltip-up');
            } else {
                tooltipMainStyles.top = cellPosition.top + cellHeight + tooltipXOffset;
                $tooltipMain.addClass('tooltip-bottom');
            }

            $tooltipMain.css(tooltipMainStyles).css(cssStyles).html(tooltip);

            $tooltipArrow.css({
                'left': cellPosition.left + cellWidth / 2 - left
            });
            $tooltipMain.append($tooltipArrow);

            $tooltipMain.appendTo(document.body);

            $target[0].attachedTooltipContainer = $tooltipMain[0];
        },
        onMouseLeaveTooltipTarget(event) {
            let $target = $(event.currentTarget);

            if (!($target[0].dataset.tooltip)) {
                return;
            }

            $($target[0].attachedTooltipContainer).remove();
            event.target.attachedTooltipContainer = null;
        },
    }
})

Vue.filter('smart_s', (word, count) => {
    if (count > 1) {
        return word + 's';
    }
    return word;
})

Vue.directive('focus', {
    inserted: function (el) {
        el.focus()
    }
})

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
